import { Link } from 'react-router-dom';
import { seriesList } from '@/mocks/series';
import { statusInfo } from '@/utils/series';

const HERO_BG =
  'https://readdy.ai/api/search-image?query=Wide%20flat%20modern%20editorial%20illustration%20of%20a%20playful%20watermelon%20party%20scene%20with%20watermelon%20slices%20popcorn%20drama%20masks%20and%20popcorn%20boxes%20floating%2C%20vibrant%20coral%20orange%20red%20background%20with%20mint%20green%20accents%2C%20soft%20rounded%20shapes%2C%20high%20detail%2C%20energetic%20but%20not%20busy&width=1920&height=1000&seq=hero-chigua&orientation=landscape';

export default function Hero() {
  const hot = [...seriesList]
    .filter((s) => s.episodes.length > 0)
    .sort((a, b) => b.heat - a.heat)
    .slice(0, 5);

  return (
    <section className="relative flex min-h-[660px] w-full items-center overflow-hidden md:min-h-[720px]">
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="吃瓜每日 吃瓜连续剧追更平台视觉背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary-700/95 via-primary-600/85 to-primary-500/75"></div>
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-primary-900/40 to-transparent"></div>
      </div>

      <div className="relative mx-auto w-full px-4 py-20 md:px-6">
        <div className="mx-auto w-full max-w-4xl text-center">
          <p className="mx-auto inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
            <span className="flex h-2 w-2 rounded-full bg-secondary-400"></span>
            连续剧式吃瓜 · 剧情更新 · 后续进展 · 系列跟踪
          </p>

          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            吃瓜不迷路
            <br className="md:hidden" />
            <span className="inline-block px-2 md:px-3">追更更上头</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-background-100/90 md:text-lg md:leading-8">
            把娱乐圈里那些有反转、有后续、成系列的瓜料，整理成一部部可按集追更的「连续剧」。
            剧情更新、后续进展、第N集、系列走向一网打尽，让你不错过每一个瓜的后续发展。
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/chasing"
              className="flex h-12 w-full items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-8 text-base font-bold text-primary-700 shadow-sm transition-transform hover:-translate-y-0.5 hover:bg-background-100 sm:w-auto"
            >
              开始追更
              <i className="ri-play-circle-line ml-2 text-lg"></i>
            </Link>
            <a
              href="#fresh"
              className="flex h-12 w-full items-center justify-center whitespace-nowrap rounded-full border border-background-50/40 px-8 text-base font-bold text-background-50 transition-colors hover:bg-background-50/15 sm:w-auto"
            >
              看今天的新鲜瓜
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-background-50/90">
            {[
              ['40+', '持续更新的瓜局'],
              ['6', '热门追更类型'],
              ['7×24', '随热更新不缺席'],
            ].map(([num, label]) => (
              <div key={label} className="flex items-center gap-2.5">
                <span className="font-heading text-2xl text-background-50 md:text-3xl">{num}</span>
                <span className="text-sm text-background-100/85">{label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-2xl border border-background-50/20 bg-background-50/10 backdrop-blur-md">
          <div className="flex items-center gap-2 border-b border-background-50/15 px-4 py-2.5 text-sm font-bold text-background-50">
            <i className="ri-flashlight-line text-secondary-400"></i>
            正在火热追更
            <span className="ml-1 flex h-2 w-2 rounded-full bg-secondary-400"></span>
          </div>
          <div className="flex flex-col">
            {hot.map((s) => {
              const last = s.episodes[s.episodes.length - 1];
              return (
                <Link
                  key={s.id}
                  to={`/story/${s.id}`}
                  className="group flex items-center gap-3 px-4 py-2.5 transition-colors hover:bg-background-50/10"
                >
                  <span className={`h-2 w-2 shrink-0 rounded-full ${statusInfo[s.status].dot}`}></span>
                  <span className="w-16 shrink-0 whitespace-nowrap rounded-md bg-background-50/15 px-1.5 py-0.5 text-center text-xs font-bold text-secondary-300">
                    {last?.ep}
                  </span>
                  <span className="flex-1 truncate text-sm text-background-50/95 group-hover:font-medium">
                    {last?.title}
                  </span>
                  <span className="hidden shrink-0 text-xs text-background-100/70 sm:inline">
                    {last?.tag} · {s.updated}
                  </span>
                  <i className="ri-arrow-right-s-line text-background-100/70 transition-transform group-hover:translate-x-1"></i>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}